import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import {makeGet} from '@yandex-delivery/utils'

import type {AddressPin, SimpleAddressPin, UserAddressPin} from '../../model/types'
import {isUserAddressPin} from '../../utils/isUserAddressPin'

export function toSimpleAddressPin(obj: SuggestObject): SimpleAddressPin {
  return {
    __type: 'simple-address-pin',
    coordinates: getPosition(obj),
    title: getTitle(obj),
    subtitle: getSubtitle(obj),
    city: getCity(obj),
  }
}

export function toUserAddressPin(obj: SuggestObject | AddressPin): UserAddressPin {
  if ('__type' in obj) {
    if (isUserAddressPin(obj)) {
      return obj
    }

    return {
      __type: 'user-address-pin',
      coordinates: obj.coordinates,
      title: obj.title,
      subtitle: obj.subtitle,
      city: obj.city,
    }
  }

  return {
    __type: 'user-address-pin',
    coordinates: getPosition(obj),
    title: getTitle(obj),
    subtitle: getSubtitle(obj),
    city: getCity(obj),
    trail: getTrail(obj),
    country: getCountry(obj),
    building: getBuilding(obj),
    street: getStreet(obj),
    uri: getUri(obj),
  }
}

export function toUserAddressIntercityPin(obj: SuggestObject): UserAddressPin {
  const newTitle = `${getCity(obj)}, ${getTitle(obj)}`
  return {
    __type: 'user-address-pin',
    coordinates: getPosition(obj),
    title: newTitle,
    subtitle: getSubtitle(obj),
    city: getCity(obj),
    trail: getTrail(obj),
    country: getCountry(obj),
    building: getBuilding(obj),
    street: getStreet(obj),
    uri: getUri(obj),
  }
}

const suggestGetter = makeGet<SuggestObject>()
const getPosition = suggestGetter('position')
const getTitle = suggestGetter('title.text')
const getSubtitle = suggestGetter('subtitle.text')
const getCity = suggestGetter('city')
const getCountry = suggestGetter('country')
const getBuilding = suggestGetter('house')
const getStreet = suggestGetter('street')
const getUri = suggestGetter('uri')
const getTrail = suggestGetter('distance.text')
